export class MessageBusApiEndpoints {

    private readonly url: string;

    constructor(url: string) {
        this.url = url;
    }

    get track(): string {
        return `${this.url}/intake/events`;
    }
}
